import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { useSiteMap } from '@unisporkal/sites';
import {
  RichText,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import { CopyButton } from '../../molecules/CopyButton';
import { type NotDownloadedAssetsProps } from './types';
import styles from './NotDownloadedAssets.module.scss';

const NotDownloadedAssets: React.FC<NotDownloadedAssetsProps> = ({
  assetIds,
  isQuotaExceeded,
}) => {
  const t = useTranslations();
  const siteMap = useSiteMap();
  const assetIdList = assetIds.join(', ');

  return (
    <section
      className={styles.container}
      data-testid="not-downloaded-assets"
    >
      {isQuotaExceeded ? (
        <p
          className={styles.label}
          data-testid="not-downloaded-assets-quota-met-label"
        >
          {t('zero_downloads_remaining')}{' '}
          <RichText
            component={TypographyComponentEnum.SPAN}
            variant={TypographyVariant.body.small}
            className={styles.label}
          >
            {t('contact_us_to_update_agreement', {
              links: [
                {
                  href: siteMap.contact(),
                  target: '_blank',
                  rel: 'noopener noreferrer',
                },
              ],
            })}
          </RichText>
        </p>
      ) : (
        <p className={styles.label}>{t('assets_not_downloaded_heading')}</p>
      )}
      <div className={styles.wrapper}>
        <textarea
          readOnly
          className={styles.textarea}
          value={assetIdList}
          data-testid="not-downloaded-assets-textarea"
        />
        <CopyButton
          value={assetIdList}
          ariaLabel={t('copy_to_clipboard')}
          className={styles.copyButton}
          iconSize={14}
          data-testid="not-downloaded-assets-copy-button"
        />
      </div>
    </section>
  );
};

export default NotDownloadedAssets;
